import React from "react";
import TeamSection from "../components/TeamSection";

const OurTeamPage = () => {
  return (
    <>
      <TeamSection />
    </>
  )
};

export default OurTeamPage;
